import { render, staticRenderFns } from "./Consentimientos.vue?vue&type=template&id=53e74a46"
import script from "./Consentimientos.vue?vue&type=script&lang=js"
export * from "./Consentimientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports